export default __webpack_public_path__ + "static/media/triceps_kickback_start.294c274d.svg";